import { bool, array, arrayOf, shape, string } from "prop-types"
import SimpleRegistration from "./SimpleRegistration"
import DetailRegistration from "./DetailRegistration"

const Show = ({
  event,
  registration,
  attendeeTypes,
  isActingStaff,
  isAdmin,
  isRegisterForSeparateEventsEnabled,
  signupTimes
}) => {
  return (
    <>
      {event.isSimple ? (
        <SimpleRegistration
          event={event}
          registration={registration}
          isActingStaff={isActingStaff}
          isAdmin={isAdmin}
          isRegisterForSeparateEventsEnabled={isRegisterForSeparateEventsEnabled}
          signupTimes={signupTimes}
        />
      ) : (
        <DetailRegistration
          event={event}
          registration={registration}
          attendeeTypes={attendeeTypes}
          isActingStaff={isActingStaff}
          isAdmin={isAdmin}
        />
      )}
    </>
  )
}

Show.propTypes = {
  attendeeTypes: arrayOf(shape({})),
  event: shape({
    isSimple: bool,
    paths: shape({
      show: string
    })
  }),
  registration: shape({
    restoreAlertText: string,
    paths: shape({
      show: string,
      finalize: string,
      cancel: string,
      confirmEmail: string
    })
  }),
  isActingStaff: bool,
  isAdmin: bool,
  isRegisterForSeparateEventsEnabled: bool,
  signupTimes: array
}

export default Show
